exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chanel_da h2[data-v-a0c01e00]{color:#000}.chanel_da[data-v-a0c01e00]{color:#000;font-size:12px}.c_v[data-v-a0c01e00]{margin-top:12px;margin-bottom:12px}.channel-header-right[data-v-a0c01e00],.user-header-right[data-v-a0c01e00]{-ms-flex-preferred-size:1px!important;flex-basis:1px!important}.pur_p[data-v-a0c01e00]{background-color:#8293ca!important;color:#fff;padding:10px 12px 14px}.home-wrapper .nav .container[data-v-a0c01e00],.home-wrapper .nav[data-v-a0c01e00]{min-height:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a0c01e00","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/LocationHeader.vue
// module id = C1fr
// module chunks = 0